export const NUMBER_PLACE_HOLDER = "-,---"
export const DATE_PLACE_HOLDER = "mm,dd,yyyy"
export const DATE_RANGE_PLACE_HOLDER = "mm,dd,yyyy - mm,dd,yyyy"
